module.exports = __webpack_public_path__ + "assets/images/list_purple.svg?7158c6361038b4adddfc4df3cc6a9307";


//////////////////
// WEBPACK FOOTER
// ./_source/images/icons/sessions/list_purple.svg
// module id = 625
// module chunks = 0